import { render, staticRenderFns } from "./proc.vue?vue&type=template&id=8f18e664&scoped=true"
import script from "./proc.vue?vue&type=script&lang=js"
export * from "./proc.vue?vue&type=script&lang=js"
import style0 from "./proc.vue?vue&type=style&index=0&id=8f18e664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f18e664",
  null
  
)

export default component.exports